import { isPlatformBrowser } from '@angular/common';
import type { OnDestroy } from '@angular/core';
import { Inject, PLATFORM_ID, Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import type { AppState } from '@capacitor/app/dist/esm/definitions';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';

/**
 * A thin wrapper around Capacitor App API
 * It exposes Observables to make it easier to reuse in Other services
 */
@Injectable({
  providedIn: 'root',
})
export class AppService implements OnDestroy {
  private appStateSubject$ = new Subject<AppState>();
  private listener?: { remove(): void };

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  private async initAppStateListener(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      this.listener = await App.addListener('appStateChange', state => {
        this.appStateSubject$.next(state);
      });
    }
  }

  get appState$(): Observable<AppState> {
    if (!this.listener) {
      this.initAppStateListener();
    }
    return this.appStateSubject$.asObservable();
  }

  ngOnDestroy(): void {
    this.listener?.remove();
  }
}
